export const environment = {
  production: true,
  instantPaiementApi: "http://paiement-api.instant-bocal.com/",
  imageBaseUri: "http://paiement-api.instant-bocal.com"
};



// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/environments/environment.ts